import React, { useState } from "react";
import styled from "styled-components";
import { eventDetails, eventSpeakersData } from "../../../assets/data/event-page/eventPageData";
import { Colors } from "../../../utils/colors/colors";
import Carousel from "react-multi-carousel";
import GhanaEventsDetails from "./GhanaEventDetail";
import IbadanEventsDetails from "./IbadanEventDetail";
import SpeakerCard from "./SpeakerCard";




const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export default function EventDetails() {
  const [carouselCurrentSlide, setCarouselCurrentSlide] = useState(3);
  const {generalInfo} = eventDetails()

  const { primaryColor, secondaryColor } = Colors();

  return (
    <EventDetailsWrapper>
      <EventHighlight>
        <Text
          data-aos-once="true"
          data-aos="fade-up"
          style={{
            color: secondaryColor,
          }}
        >
          {generalInfo.subTitle}
        </Text>
        <EventTitleText
          data-aos-once="true"
          data-aos="fade-up"
          style={{
            color: primaryColor,
          }}
        >
          {generalInfo.title}
        </EventTitleText>
      </EventHighlight>

      <Carousel
        arrows={false}
        swipeable={true}
        centerMode={false}
        draggable={true}
        showDots={false}
        responsive={responsive}
        ssr={true} // means to render carousel on server-side.
        infinite={true}
        slidesToSlide={1}
        autoPlay={true}
        rewind={true}
        rewindWithAnimation={true}
        keyBoardControl={true}
        autoPlaySpeed={5000}
        customTransition="transform 1000ms ease-in-out"
        transitionDuration={1000}
        containerClass="carousel-container"
        removeArrowOnDeviceType={["tablet", "mobile"]}
        dotListClass=""
        itemClass=""
        beforeChange={(previousSlide, { currentSlide, onMove }) => {
          setCarouselCurrentSlide(currentSlide);
        }}
      >
        <GhanaEventsDetails
          currentSlide={carouselCurrentSlide}
          setCarouselCurrentSlide={setCarouselCurrentSlide}
        />
        <IbadanEventsDetails
          currentSlide={carouselCurrentSlide}
          setCarouselCurrentSlide={setCarouselCurrentSlide}
        />
      </Carousel>

      <AboutEventWrapper>
        <Text>About Event</Text>
        <AboutEventText
          data-aos-once="true"
          data-aos="fade-up"
          dangerouslySetInnerHTML={{ __html: generalInfo.description }}
        />
      </AboutEventWrapper>

      <SpeakerDetailsWrapper>
        <SpeakerText>Speaker(s)</SpeakerText>
        <SpeakersWrapper>
          {eventSpeakersData.map((speakers) => (
            <SpeakerCard {...speakers} key={speakers.id} />
          ))}
        </SpeakersWrapper>
      </SpeakerDetailsWrapper>

    </EventDetailsWrapper>
  );
}

const EventDetailsWrapper = styled.div``;

const EventHighlight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 10px;
`;

const Text = styled.p`
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
  text-transform: uppercase;
  color: #fc8212;

  @media (min-width: 476px) {
    font-size: 21px;
  }
`;

const EventTitleText = styled.p`
  font-family: "Lato";
  font-style: normal;
  font-weight: 800;
  font-size: 32px;
  line-height: 120%;
  display: flex;
  align-items: center;
  text-transform: uppercase;

  @media (min-width: 476px) {
    font-size: 52px;
  }
`;

const AboutEventWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 40px;
`;

const AboutEventText = styled.div`
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 200%;
  color: #303030;
  opacity: 0.9;
`;


const SpeakersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
`;
const SpeakerText = styled.p`
font-family: 'Lato';
font-style: normal;
font-weight: 900;
font-size: 18px;
line-height: 200%;
color: #FC8212;
opacity: 0.9;
  padding: 0px;
margin:0
`

const SpeakerDetailsWrapper = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
padding: 0px;
gap: 10px;
margin-top:40px;

`